import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/order/returnVisitPage', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/order/reutrnvisit/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/order/reutrnvisit/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/order/reutrnvisit/submit', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/order/reutrnvisit/submit', params,options)

export const returnVisit = (params, options) =>
  request.get('/api/v4ward/order/reutrnvisit/returnVisit', Object.assign({}, options, { params }));



  export const returnVisited = (params, options) =>
  request.get('/api/v4ward/order/reutrnvisit/page', Object.assign({}, options, { params }));
//已回访详情
  export const returnVisitedRecord = (params, options) =>
  request.get('/api/v4ward/order/reutrnvisit/detail', Object.assign({}, options, { params }));